import { IconStyle as T, TagStyle as O, Theme as R, AccountType as g } from "@nextgen-web-framework/all";
import { ConfigService as y, DateFormats as m, formatDateTime as U, ApiConfigService as B, DateOrTime as I, TimeFormats as h } from "@nextgen-web-framework/core";
import { L as Q, r as C, C as V, I as L, A as M } from "./postpurchaseEnums-19d3e31f.mjs";
var F = /* @__PURE__ */ ((n) => (n.Purchase = "purchase", n))(F || {}), w = /* @__PURE__ */ ((n) => (n.HOMEDELIVERY = "homedelivery", n.BOPIS = "bopis", n.SEVEN_ELEVEN = "seveneleven", n.WALKIN = "walkin", n.KERRY = "kerry", n.EASY_DELIVERY = "easydeliverypoint", n))(w || {});
const D = {
  homedelivery: [
    "homedelivery"
    /* HOMEDELIVERY */
  ],
  bopis: [
    "bopis",
    "seveneleven",
    "walkin",
    "kerry",
    "easydeliverypoint"
    /* EASY_DELIVERY */
  ]
};
var x = /* @__PURE__ */ ((n) => (n.PACKAGE_COMPLETED = "PACKAGE_COMPLETED", n.PACKAGE_OUT_FOR_DELIVERY = "PACKAGE_OUT_FOR_DELIVERY", n.PACKAGE_PREPARING = "PACKAGE_PREPARING", n.READY_FOR_COLLECTION = "READY_FOR_COLLECTION", n.PACKAGE_UNDELIVERED = "PACKAGE_UNDELIVERED", n))(x || {});
const en = {
  Web: "Web",
  CommerceWeb: "Commerce Web",
  CustomerService: "Customer Service",
  RecurringOrder: "Recurring Order",
  Subscription: "Subscription",
  POS: "Point of Sale",
  CommerceApp: "Commerce App",
  BodyKey: "Body Key",
  DMS: "DMS",
  Line: "Line",
  WebMobile: "Web Mobile",
  TMS: "TMS"
};
var G = /* @__PURE__ */ ((n) => (n.POOL = "POOL", n.VARIANT = "VARIANT", n.FIXED = "FIXED", n))(G || {});
function S(n) {
  var l;
  return (n == null ? void 0 : n.bundleProducts) && ((l = n == null ? void 0 : n.bundleProducts) == null ? void 0 : l.length) > 0;
}
function K(n) {
  var l;
  return (n == null ? void 0 : n.subscriptionProducts) && ((l = n == null ? void 0 : n.subscriptionProducts) == null ? void 0 : l.length) > 0;
}
function tn(n) {
  if (n != null && n.bundleProducts && S(n)) {
    for (const l of n.bundleProducts)
      if ((l == null ? void 0 : l.subscriptionElementId) !== void 0)
        return !0;
  }
  return (n == null ? void 0 : n.subscriptionElementId) !== void 0;
}
function $(n, l, t) {
  return t ? l ? n.calculatedBundleOrderLineTotal : n.orderLineTotal : l ? n.calculatedBundleOriginalLineTotalValue : n.originalLineTotalValue;
}
function k(n, l) {
  return l ? n.calculatedBundlePrice : n.linePrice;
}
function Y(n, l, t) {
  var u, o;
  return t ? (u = l ? n == null ? void 0 : n.calculatedBundleLinePVAmount : n == null ? void 0 : n.linePVAmount) == null ? void 0 : u.toString() : (o = l ? n == null ? void 0 : n.calculatedBundleOriginalLinePVAmount : n == null ? void 0 : n.originalLinePVAmount) == null ? void 0 : o.toString();
}
function z(n, l, t) {
  var u, o;
  return t ? (u = l ? n == null ? void 0 : n.calculatedBundleLineBVAmount : n == null ? void 0 : n.lineBVAmount) == null ? void 0 : u.toString() : (o = l ? n == null ? void 0 : n.calculatedBundleOriginalLineBVAmount : n == null ? void 0 : n.originalLineBVAmount) == null ? void 0 : o.toString();
}
function W(n, l) {
  var t, u, o, r, i, d, a, c, s, v;
  return {
    brandName: n == null ? void 0 : n.itemBrand,
    productName: n.itemDescription || "",
    productSize: n.itemSize || "",
    servingSize: n.itemSize || "",
    alt: (u = (t = n == null ? void 0 : n.media) == null ? void 0 : t.main) == null ? void 0 : u.altText,
    link: (r = (o = n == null ? void 0 : n.media) == null ? void 0 : o.main) == null ? void 0 : r.publicUrl,
    thumbnail: (d = (i = n == null ? void 0 : n.media) == null ? void 0 : i.main) == null ? void 0 : d.publicUrl,
    main: ((c = (a = n == null ? void 0 : n.media) == null ? void 0 : a.main) == null ? void 0 : c.publicUrl) ?? ((v = (s = n == null ? void 0 : n.media) == null ? void 0 : s.zoom) == null ? void 0 : v.publicUrl),
    productId: n == null ? void 0 : n.baseItemId,
    stockStatus: "",
    currency: l,
    orderLineId: n.orderLineId,
    showLinkForProductCard: !(n != null && n.restrictFromPdpDisplay)
  };
}
function X(n, l, t) {
  var u, o, r, i, d, a, c, s;
  const v = t ? (o = (u = n == null ? void 0 : n.bundleProducts) == null ? void 0 : u[0]) == null ? void 0 : o.inventoryReservationLineId : n == null ? void 0 : n.inventoryReservationLineId;
  return {
    ...W(n, l),
    inventoryReservationLineId: v || ((a = (d = (i = (r = n == null ? void 0 : n.subscriptionProducts) == null ? void 0 : r[0]) == null ? void 0 : i.bundleProducts) == null ? void 0 : d[0]) == null ? void 0 : a.inventoryReservationLineId) || ((s = (c = n == null ? void 0 : n.subscriptionProducts) == null ? void 0 : c[0]) == null ? void 0 : s.inventoryReservationLineId),
    restrictFromReturns: n == null ? void 0 : n.restrictFromReturns,
    strikethroughPrice: n == null ? void 0 : n.calculatedStrikeOutPrice,
    calculatedBundleReturnableQuantity: n == null ? void 0 : n.calculatedBundleReturnableQuantity,
    cancelledQuantity: n == null ? void 0 : n.cancelledQuantity,
    deliveryDate: b(
      n == null ? void 0 : n.actualDeliveryDate,
      m.MEDIUM_DATE,
      void 0,
      I.DATE_ONLY
    ),
    dateSubText: b(
      n == null ? void 0 : n.estimatedShipDate,
      m.MEDIUM_DATE,
      void 0,
      I.DATE_ONLY
    ),
    subscriptionProduct: n.subscriptionProducts
  };
}
function _(n, l) {
  return n ? [l] : [];
}
function N(n) {
  return (n == null ? void 0 : n.calculatedIsReturnEnabled) === !1 ? !1 : n != null && n.calculatedIsReturnEnabled ? (n == null ? void 0 : n.restrictFromReturns) === !0 ? !1 : !(n != null && n.restrictFromReturnsOnline) : (n == null ? void 0 : n.calculatedIsReplacementEnabled) === !1 ? !1 : n != null && n.calculatedIsReplacementEnabled ? (n == null ? void 0 : n.isDeliveryAvailable) && ["IN_STOCK", "LOW_STOCK"].includes((n == null ? void 0 : n.derivedAvailabilityStatus) || "") : !1;
}
function un(n, l, t, u, o, r, i) {
  var d, a, c, s, v, e;
  return {
    ...X(n, l, u),
    productName: (n == null ? void 0 : n.subscriptionPlanName) || n.itemDescription || "",
    productSize: n != null && n.subscriptionCode ? `Subscription ID: ${n.subscriptionCode}` : n.itemSize || "",
    itemPrice: k(n, u),
    totalTax: n == null ? void 0 : n.lineTaxTotalAmount,
    productPrice: (n == null ? void 0 : n.calculatedSubscriptionOriginalLineTotalValue) || $(n, u, t),
    showZeroAsFree: !r,
    productQuantity: o ? i ? (a = (d = n == null ? void 0 : n.fulfillments) == null ? void 0 : d[0]) == null ? void 0 : a.calculatedGroupedFulfilledQuantity : (s = (c = n == null ? void 0 : n.fulfillments) == null ? void 0 : c[0]) == null ? void 0 : s.fulfilledQuantity : q(n, t, u),
    isTNAProduct: Number(n == null ? void 0 : n.unallocatedQuantity) > 0,
    derivedAvailabilityStatus: n != null && n.qtyInitiallyBackordered && !t ? "BO" : "",
    isCancelled: n.isCancelled,
    businessVolume: ((v = n == null ? void 0 : n.calculatedSubscriptionOriginalLineBVAmount) == null ? void 0 : v.toString()) || z(n, u, t),
    pointValue: ((e = n == null ? void 0 : n.calculatedSubscriptionOriginalLinePVAmount) == null ? void 0 : e.toString()) || Y(n, u, t),
    isReturnEnabled: u ? n.calculatedIsBundleReturnEnabled : N(n),
    tags: [
      ..._((n == null ? void 0 : n.calculatedIsPromotionalItem) && !n.isAuxiliaryProduct, {
        icon: {
          iconName: "tags",
          iconStyle: T.REGULAR
        },
        text: "",
        style: O.SOLID,
        theme: R.SUCCESS
      }),
      ..._((n == null ? void 0 : n.subscriptionElementId) !== void 0, {
        icon: {
          iconName: "box",
          iconStyle: T.REGULAR
        },
        text: n != null && n.subscriptionElementSequence && n != null && n.subscriptionTotalShipments ? `SOP: ${n == null ? void 0 : n.subscriptionElementSequence}/${n == null ? void 0 : n.subscriptionTotalShipments}` : "SOP",
        style: O.OUTLINE,
        theme: R.PURPLE
      })
    ],
    subscriptionID: n == null ? void 0 : n.subscriptionID,
    subscriptionElementId: n == null ? void 0 : n.subscriptionElementId,
    isBundleProduct: u,
    isSubscriptionCompensated: n == null ? void 0 : n.isSubscriptionCompensated,
    busLineCode: n == null ? void 0 : n.busLineCodeEbs,
    uom: n == null ? void 0 : n.lineUnitOfMeasure
  };
}
function q(n, l, t) {
  return l ? t ? n.calculatedBundleReturnableQuantity : n.returnableQuantity : t ? n.bundleQuantity : n.orderedQuantity;
}
function H(n, l) {
  p([{ ...n }]).forEach((t) => {
    t != null && t.cancelDocumentURL && l && l.findIndex((u) => (t == null ? void 0 : t.cancelDocumentURL) === u.url) === -1 && l.push({
      dateTime: t == null ? void 0 : t.cancelDate,
      url: t == null ? void 0 : t.cancelDocumentURL
    });
  });
}
function Z(n, l, t) {
  return t ? n == null ? void 0 : n.derivedAvailabilityStatus : n != null && n.cancelledQuantity && (n == null ? void 0 : n.cancelledQuantity) > 0 && !l ? "CANCELLED" : n != null && n.qtyInitiallyBackordered ? "BO" : "";
}
function on(n, l, t, u, o, r) {
  var i;
  const d = [];
  let a = !1, c = 0, s = 0, v = !0;
  return (i = n.bundleProducts) == null || i.forEach((e) => {
    var A, P, f, E;
    H(e, t), e != null && e.cancelledQuantity && e.cancelledQuantity > 0 && (a = !0), e != null && e.lineTaxTotalAmount && (c += e == null ? void 0 : e.lineTaxTotalAmount), e != null && e.linePrice && (s += e == null ? void 0 : e.linePrice), e != null && e.calculatedIsReturnEnabled && (v = !1), d.push({
      productId: e.baseItemId || "",
      brandName: e.itemBrand || "",
      productName: e.itemDescription || "",
      alt: ((P = (A = e.media) == null ? void 0 : A.main) == null ? void 0 : P.altText) || "",
      link: ((E = (f = e.media) == null ? void 0 : f.main) == null ? void 0 : E.publicUrl) || "",
      quantity: e != null && e.returnOrderlineQuantity ? e.returnOrderlineQuantity : l && e.returnableQuantity !== void 0 && !r ? e.returnableQuantity : o && (e == null ? void 0 : e.replacementOrderlineQuantity) !== void 0 ? e == null ? void 0 : e.replacementOrderlineQuantity : e.orderedQuantity || 0,
      servingSize: e.itemSize || "",
      uom: e.lineUnitOfMeasure,
      busLineCode: e.busLineCodeEbs,
      parentOrderLineId: (e == null ? void 0 : e.parentOrderLineId) || (e == null ? void 0 : e.inventoryReservationLineId),
      baseitemId: e.baseItemId,
      selectedReturnQuantity: o ? e.replacementBundleQuantity : e.returnOrderlineQuantity,
      returnableQuantity: e.returnableQuantity,
      bundleItemId: e == null ? void 0 : e.bundleItemId,
      bundleLineId: e == null ? void 0 : e.bundleLineId,
      subscriptionID: e == null ? void 0 : e.subscriptionID,
      subscriptionElementId: e == null ? void 0 : e.subscriptionElementId,
      returnItemUserImageUrl: e == null ? void 0 : e.returnItemUserImageUrl,
      returnReason: e == null ? void 0 : e.returnReason,
      returnComment: e == null ? void 0 : e.returnComment,
      parentOrderLineQuantity: e == null ? void 0 : e.orderedQuantity,
      parentOrderBundleQuantity: e == null ? void 0 : e.bundleQuantity,
      lineBVAmount: e == null ? void 0 : e.lineBVAmount,
      linePVAmount: e == null ? void 0 : e.linePVAmount,
      orderLineTotal: e == null ? void 0 : e.orderLineTotal,
      returnLineId: e == null ? void 0 : e.returnLineId,
      inventoryReservationLineId: e == null ? void 0 : e.inventoryReservationLineId,
      cancelledQuantity: e == null ? void 0 : e.cancelledQuantity,
      derivedAvailablityStatus: Z(e, u, o),
      firstAvailableFutureDate: e == null ? void 0 : e.estimatedShipDate,
      itemPrice: e == null ? void 0 : e.linePrice,
      totalTax: e == null ? void 0 : e.lineTaxTotalAmount,
      productPrice: e == null ? void 0 : e.originalLineTotalValue,
      isReturnEnabled: N(e),
      returnedQty: 1,
      isPromotionApplied: !(n != null && n.calculatedIsPromotionalItem) && (e == null ? void 0 : e.calculatedIsPromotionalItem) && !e.isAuxiliaryProduct
    });
  }), {
    bundleData: d,
    hasCancelledItemsInBundle: a,
    totalTaxAmount: c,
    totalItemPrice: s,
    noItemEligible: v
  };
}
function rn(n) {
  var l;
  const t = [];
  return (l = n == null ? void 0 : n.bundleProducts) == null || l.forEach((u, o) => {
    t.push({
      id: `${o}`,
      entries: [
        {
          product: {
            id: (u == null ? void 0 : u.baseItemId) || ""
          },
          quantity: u.orderedQuantity || 0
        }
      ]
    });
  }), t;
}
function dn(n) {
  const l = new Date(n), t = l.getFullYear(), u = (l.getMonth() + 1).toString().padStart(2, "0"), o = l.getDate().toString().padStart(2, "0");
  return `${t}-${u}-${o}`;
}
function an(n) {
  let l = n ? n.toLowerCase() : "homedelivery";
  for (const t in D)
    D[t].indexOf(n.toLowerCase()) >= 0 && (l = t);
  return l;
}
function cn(n) {
  var l, t, u, o, r, i, d;
  const a = S((l = n == null ? void 0 : n.orderLines) == null ? void 0 : l[0]) ? (r = (o = (u = (t = n == null ? void 0 : n.orderLines) == null ? void 0 : t[0]) == null ? void 0 : u.bundleProducts) == null ? void 0 : o[0]) == null ? void 0 : r.fulfillmentType : (d = (i = n == null ? void 0 : n.orderLines) == null ? void 0 : i[0]) == null ? void 0 : d.fulfillmentType;
  return (a == null ? void 0 : a.toLowerCase()) || "";
}
function sn(n) {
  return Q.HYBRIS === (n == null ? void 0 : n.sourceOms) ? n.orderStatus && C[n.orderStatus] ? C[n.orderStatus] : n.orderStatus : n == null ? void 0 : n.calculatedOrderStatus;
}
function vn({ htmlString: n, dynamicData: l }) {
  let t = "";
  return n && (t = n.replace(
    /\{(\w+)\}/g,
    (u, o) => l[o] !== void 0 ? l[o] : u
  )), t;
}
function mn(n) {
  return V.CANCELLED.includes(n || "");
}
function j(n, l) {
  const t = [];
  return n == null || n.forEach((u) => {
    var o;
    const r = l == null ? void 0 : l.find((i) => i.reason_code === (u == null ? void 0 : u.cancelReason));
    t.push({
      cancelDate: b(
        u == null ? void 0 : u.cancelDateTime,
        m.MEDIUM_DATE,
        void 0,
        I.DATE_ONLY
      ),
      cancelReason: r != null && r.reason_code && M.includes(r == null ? void 0 : r.reason_code) ? u == null ? void 0 : u.note : (r == null ? void 0 : r.reason_description) || ((o = n == null ? void 0 : n[0]) == null ? void 0 : o.cancelReason),
      cancelTime: b(
        u == null ? void 0 : u.cancelDateTime,
        void 0,
        h.SHORT_TIME,
        I.TIME_ONLY
      ),
      cancelDocumentURL: u == null ? void 0 : u.cancelDocumentURL,
      cancelledByUser: u == null ? void 0 : u.cancelledByUser,
      cancelComments: u == null ? void 0 : u.note
    });
  }), t;
}
function p(n, l) {
  var t, u, o;
  let r = [];
  return n && S(n == null ? void 0 : n[0]) ? r = p((t = n == null ? void 0 : n[0]) == null ? void 0 : t.bundleProducts, l) : n && K(n == null ? void 0 : n[0]) ? r = p((u = n == null ? void 0 : n[0]) == null ? void 0 : u.subscriptionProducts, l) : r = j((o = n == null ? void 0 : n[0]) == null ? void 0 : o.cancellations, l), r;
}
const In = (n, l) => {
  const t = L.find((u) => u.sourceOms === l);
  return t ? t.OrderDetailsCTAs.includes(n) : !0;
}, bn = (n, l, t) => {
  const u = L.find((o) => o.sourceOms === t);
  return l && u ? u.OrderHistoryCTAs.includes(n) : l;
}, pn = (n, l, t) => {
  const u = L.find((o) => o.sourceOms === t);
  return l && u ? u.OrderDetailsCTAs.includes(n) : l;
};
function b(n, l, t, u) {
  const o = y.getConfigs();
  if (!n)
    return "";
  const { locale: r } = PreferenceService.getPreferences();
  let i;
  return r === "es-co" ? i = m.LONG_DATE : i = l, U(
    n,
    { date: i, time: t },
    !1,
    o.NEXT_PUBLIC_TIMEZONE,
    r || void 0,
    u
  );
}
const yn = (n, l) => {
  var t, u, o, r;
  return (r = (o = (u = (t = n == null ? void 0 : n[0]) == null ? void 0 : t.types) == null ? void 0 : u.find(
    (i) => {
      var d;
      return ((d = i.fulfillment_type_id) == null ? void 0 : d.toLocaleLowerCase()) === (l == null ? void 0 : l.toLocaleLowerCase());
    }
  )) == null ? void 0 : o.image) == null ? void 0 : r.url;
}, Ln = (n) => {
  const l = B.getTuples(), t = y.getConfigs();
  let u = "";
  if (typeof window < "u") {
    const o = {
      redirectUri: window.location.href,
      headers: l,
      amwayLang: n
    };
    t.NEXT_PUBLIC_LOGIN_URL && (o.loginUrl = t.NEXT_PUBLIC_LOGIN_URL), u = btoa(JSON.stringify(o));
  }
  return {
    scope: "openid",
    state: u,
    countryIso: l["X-Amway-Country"],
    redirectUri: t.NEXT_PUBLIC_OIDC_URL ? `${t.NEXT_PUBLIC_OIDC_URL}` : ""
  };
}, Sn = (n, l) => {
  var t, u, o, r;
  if (n === ((t = l == null ? void 0 : l.orderingSalesAccount) == null ? void 0 : t.accountId))
    return (u = l == null ? void 0 : l.orderingSalesAccount) == null ? void 0 : u.businessNature;
  if (n === ((o = l == null ? void 0 : l.orderForSalesAccount) == null ? void 0 : o.accountId))
    return (r = l == null ? void 0 : l.orderForSalesAccount) == null ? void 0 : r.businessNature;
}, An = (n) => g.BusinessOwner === n, Pn = (n) => g.Member === n, fn = "SOP", En = (n) => {
  const l = y.getConfigs();
  return n ? `${l.NEXT_ASSETS_BASE_PATH}/${n}` : "";
};
export {
  b as A,
  An as C,
  pn as E,
  an as I,
  W as J,
  p as L,
  mn as P,
  Sn as R,
  vn as S,
  In as T,
  _ as V,
  En as _,
  S as a,
  w as b,
  H as c,
  Z as d,
  G as e,
  on as f,
  bn as g,
  Pn as h,
  Ln as i,
  dn as j,
  en as k,
  cn as l,
  rn as m,
  yn as n,
  x as o,
  F as p,
  un as s,
  tn as t,
  fn as v,
  sn as y
};
//# sourceMappingURL=commonUtils-a7a518e4.mjs.map
